import { render, staticRenderFns } from "./DeleteBrigade.vue?vue&type=template&id=7e0697f4&scoped=true&"
import script from "./DeleteBrigade.vue?vue&type=script&lang=js&"
export * from "./DeleteBrigade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e0697f4",
  null
  
)

export default component.exports
import {QCard,QCardSection,QItem,QInput,QSeparator,QCardActions,QBtn,ClosePopup} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QItem,QInput,QSeparator,QCardActions,QBtn}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
